import Vue from 'vue'
import Vuex from 'vuex'
import reservation from './modules/reservation'
import application from './modules/application'
import user from './modules/user'
import car from './modules/car'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    application,
    reservation,
    user,
    car
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js